import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';
import { ObservableLike } from 'type-fest';

@Injectable({
  providedIn: 'root'
})
export class BreakpointService {

  dataPadFullScreen: Observable<BreakpointState>

  
 readonly smallScreen$: Observable<boolean>


  constructor(
    breakpointObserver: BreakpointObserver
  ) {
    this.dataPadFullScreen = breakpointObserver.observe([
      '(max-width: 55rem)'
    ])

    this.smallScreen$ = breakpointObserver.observe([
      '(max-width: 55rem)'
    ]).pipe(switchMap(state => of(state.matches)))


  }
}
